import styled from "styled-components";

export const GradeTableWrapper = styled.section`
  border-radius: 4px;
  & > header {
    background-color: #452D84;
    color: white;
    font-size: 12px;
    font-weight: 600;
    padding: 8px 24px;
    overflow: hidden;
    border-radius: 4px 4px 0px 0px;
  }
  & > table {
    width: 100%;
    border-collapse: collapse;
    border: 0.5px solid #231a3d85;
  }
  & th,
  td {
    border: 0.5px solid #231a3d85;
  }
`;

export const CoverateNotesWrapper = styled.ul`
  margin-left: 1.6rem;
  margin: 8px 0px 0px 1.6rem;
`;

export const GradeTableChildrenWrapper = styled.section`
  border: 0.5px solid #231a3d85;
  border-radius: 0px 0px 4px 4px;
  padding: 16px 24px;
`;
